import "babel-polyfill"; // Provides full ES2015 environment (except for Proxies)
import "core-js/stage/4"; // Everything that has been standardized by ECMA
import "whatwg-fetch"; // global fetch function (whatwg fetch)
import smoothscroll from "smoothscroll-polyfill";

smoothscroll.polyfill();



// WEBPACK FOOTER //
// ./src/polyfills.js